import { InternalAuthProvider } from './internal-auth-provider';

export { InternalAuthProvider };
